import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.openMetadataMessageId = null
    this.openMetadataButton = null

    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
    this.boundHandleEscape = this.handleEscape.bind(this)
    this.boundCloseAll = this.closeOpenMetadata.bind(this)

    document.addEventListener('click', this.boundHandleClickOutside, true)
    document.addEventListener('keydown', this.boundHandleEscape)
    document.addEventListener('chat:close-metadata', this.boundCloseAll)
  }

  disconnect() {
    document.removeEventListener('click', this.boundHandleClickOutside, true)
    document.removeEventListener('keydown', this.boundHandleEscape)
    document.removeEventListener('chat:close-metadata', this.boundCloseAll)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const button = event.currentTarget
    const messageId = button.dataset.messageId
    const metadataDiv = document.getElementById(`metadata-${messageId}`)

    if (!metadataDiv) return

    const isSameOpen = this.openMetadataMessageId && String(this.openMetadataMessageId) === String(messageId)
    if (isSameOpen) {
      this.closeOpenMetadata()
      return
    }

    this.closeOpenMetadata()

    this.openMetadataMessageId = messageId
    this.openMetadataButton = button

    metadataDiv.classList.remove('hidden')
    metadataDiv.style.visibility = 'hidden'
    metadataDiv.style.position = 'fixed'

    const rect = button.getBoundingClientRect()
    const popupWidth = metadataDiv.offsetWidth
    const popupHeight = metadataDiv.offsetHeight

    const padding = 8
    let left = rect.right - popupWidth
    left = Math.max(padding, Math.min(left, window.innerWidth - popupWidth - padding))

    let top = rect.bottom + 6
    if (top + popupHeight + padding > window.innerHeight) {
      top = rect.top - popupHeight - 6
    }
    top = Math.max(padding, Math.min(top, window.innerHeight - popupHeight - padding))

    metadataDiv.style.left = `${left}px`
    metadataDiv.style.top = `${top}px`
    metadataDiv.style.visibility = 'visible'
  }

  closeOpenMetadata() {
    if (!this.openMetadataMessageId) return

    const metadataDiv = document.getElementById(`metadata-${this.openMetadataMessageId}`)
    if (metadataDiv) {
      metadataDiv.classList.add('hidden')
      metadataDiv.style.left = ''
      metadataDiv.style.top = ''
      metadataDiv.style.position = ''
      metadataDiv.style.visibility = ''
    }

    this.openMetadataMessageId = null
    this.openMetadataButton = null
  }

  handleClickOutside(event) {
    if (!this.openMetadataMessageId) return

    const metadataDiv = document.getElementById(`metadata-${this.openMetadataMessageId}`)
    const clickedInsidePopup = metadataDiv && metadataDiv.contains(event.target)
    const clickedToggleButton = this.openMetadataButton && this.openMetadataButton.contains(event.target)

    if (clickedInsidePopup || clickedToggleButton) return
    this.closeOpenMetadata()
  }

  handleEscape(event) {
    if (event.key !== 'Escape') return
    this.closeOpenMetadata()
  }
}
